import React, { useEffect, useState } from "react"
import { Button, Form, Modal } from "react-bootstrap"
import { injectIntl } from "react-intl"
import { isError } from "react-query"
import PaymentAccountLocationSelect from "../../common/select/PaymentAccountLocationSelect"
import LoadingSpinner from "../../common/spinner/loading.component"
import PaymentAccount from "../../payment-account/model/paymentaccount"
import PaymentAccountService from "../../payment-account/service/paymentAccountService"
import { Intl } from "../../state/helpers/IntlProps"
import Location from "../../state/location/Location"
import { messages } from "./EditLocationsMessages"
import "./modals.scss"

type Props = {
    intl: Intl,
    paymentAccounts : PaymentAccount[]
    locations : Location[]
    availableLocations : Location[]
    isLoading : boolean
    show: boolean,
    currentLocationIds : string[],
    paymentAccountMerchantId : string,
    onClose: (success: boolean) => void,
}

const PaymentAccountLocationEditModal = (props: Props) => {

    const [locationIDs, setLocationIDs] = useState<string[]>([])
    const [isLoading, setIsLoading] = useState<boolean>(false)

    const formRef = React.createRef<HTMLFormElement>()

    useEffect(() => {
        setLocationIDs(props.currentLocationIds)
    }, [props.currentLocationIds, props.show])

    const handleClose = (success = false) => {
        props.onClose(success)
    }

    const handleSubmit = (event: React.FormEvent) => {

        event.preventDefault()
        updatePaymentAccount()
    }

    const updatePaymentAccount = async () => {
        setIsLoading(true)
        const res = await PaymentAccountService.updatePaymentAccount(
            props.paymentAccountMerchantId,
            {
                locationIDs : locationIDs
            }
        )
        setIsLoading(false)
        if (!isError(res)) {
            handleClose(true)
        }
    }

    return (
        <Modal show={props.show} onHide={props.onClose}>
            <Form ref={formRef} noValidate onSubmit={handleSubmit}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        {props.intl.formatMessage(messages.editLocationsHeader, {
                            value : props.paymentAccounts.find(pa => pa.getMerchantId() === props.paymentAccountMerchantId)?.getName()
                        })}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Group>
                        <Form.Label>
                            {props.intl.formatMessage(messages.editLocationsSelectLocations)}
                        </Form.Label>
                        <PaymentAccountLocationSelect
                            locations={props.locations}
                            availableLocations={props.availableLocations}
                            isLoading={props.isLoading}
                            paymentAccounts={props.paymentAccounts}
                            selectedLocations={locationIDs}
                            currentLocationIds={props.currentLocationIds}
                            onSelect={(selectedlocationsIDs) => {
                                const newLocationsIDs = selectedlocationsIDs.length > 0 ? selectedlocationsIDs.map((option) => {
                                    if(!option.isDisabled || locationIDs.includes(option.value)) {
                                        return option.value
                                    }
                                    return null
                                }) : []
                                setLocationIDs(newLocationsIDs.filter((id) => id !== null))
                            }}
                        />
                        <Form.Text className="text-muted">
                            {props.intl.formatMessage(messages.editLocationsSelectLocationsHint)}
                        </Form.Text>
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => handleClose()}>
                        {props.intl.formatMessage(messages.editLocationsClose)}
                    </Button>
                    <Button variant="primary" type="submit" disabled={isLoading || (locationIDs.length == 0)}>
                        {isLoading && <LoadingSpinner height={18} />}
                        {!isLoading && <span>{props.intl.formatMessage(messages.editLocationsSave)}</span>}
                    </Button>
                </Modal.Footer>
            </Form>
        </Modal>
    )
}

export default injectIntl(PaymentAccountLocationEditModal)


// WEBPACK FOOTER //
// ./src/payment-processing/modals/PaymentAccountLocationEditModal.tsx